<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'SkistarAccommodationsMapping',
  props: {
    selectedAccommodations: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showMappingDialog: false,
    };
  },
  methods: {
    ...mapActions({
      importAccommodations: 'skistar/importAccommodations',
      loadAccommodationCategories: 'skistar/loadAccommodationCategories',
      loadSites: 'skistar/loadSites',
      loadSuppliers: 'skistar/loadSuppliers',
      removeImportedFromSelection: 'skistar/removeImportedFromSelection',
      setImportCategory: 'skistar/setImportCategory',
      setImportSite: 'skistar/setImportSite',
      setImportSupplier: 'skistar/setImportSupplier',
    }),
    closeMappingDialog() {
      this.showMappingDialog = false;
      const nonImportedSelectedAccommodations = this.selectedAccommodations.filter(
        accommodation => !accommodation.imported,
      ).map(accommodation => accommodation.id);
      this.removeImportedFromSelection(nonImportedSelectedAccommodations);
    },
  },
  computed: {
    ...mapState({
      categories: state => state.skistar.accommodations.categories.items,
      categoriesLoading: state => state.skistar.accommodations.categories.itemsLoading,
      category: state => state.skistar.accommodations.categories.category,
      importError: state => state.skistar.import.error,
      importLoading: state => state.skistar.import.loading,
      site: state => state.skistar.sites.site,
      sites: state => state.skistar.sites.items,
      sitesLoading: state => state.skistar.sites.itemsLoading,
      suppliers: state => state.skistar.suppliers.items,
      suppliersLoading: state => state.skistar.suppliers.itemsLoading,
      supplier: state => state.skistar.suppliers.supplier,
    }),
    isAllSelectedImported() {
      return this.selectedAccommodations.filter(
        accommodation => !accommodation.imported,
      ).length === 0;
    },
  },
  created() {
    if (!this.suppliers.length) {
      this.loadSuppliers();
    }
    if (!this.sites.length) {
      this.loadSites();
    }
    if (!this.categories.length) {
      this.loadAccommodationCategories();
    }
  },
};
</script>

<template>
  <v-layout>
    <v-flex xs12 class="text-xs-right">
      <v-btn
        :disabled="!selectedAccommodations.length"
        @click="showMappingDialog = true"
        color="success"
      >
        Import Accommodations
        <v-icon>forward</v-icon>
      </v-btn>
      <v-dialog
        v-model="showMappingDialog"
        width="800"
        persistent
      >
        <template>
        <v-card tile>
          <v-card-actions>
            <v-spacer></v-spacer>
            <template v-if="isAllSelectedImported">
              All selected accommodations are imported
              <v-btn
                @click="closeMappingDialog"
                :disabled="importLoading"
                color="red darken-1"
                flat
              >
                Close
              </v-btn>
            </template>
            <template v-else>
              <v-btn
                @click="closeMappingDialog"
                :disabled="importLoading"
                color="red darken-1"
                flat
              >
                Cancel
              </v-btn>
              <v-btn
                @click="importAccommodations(selectedAccommodations)"
                :disabled="!site || !supplier || !category"
                :loading="importLoading"
                color="success"
              >Import</v-btn>
            </template>
          </v-card-actions>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout>
              <v-flex xs4 pr-2>
                <v-autocomplete
                  @change="setImportSupplier"
                  :items="suppliers"
                  :loading="suppliersLoading"
                  :disabled="suppliersLoading || importLoading"
                  :label="$t('skistar.suppliers.suppliersLabel')"
                  item-text="name"
                  item-value="id"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs4 pl-2>
                <v-autocomplete
                  @change="setImportSite"
                  :items="sites"
                  :loading="sitesLoading"
                  :disabled="sitesLoading || importLoading"
                  :label="$t('skistar.sites.sitesLabel')"
                  :value="site"
                  item-text="name"
                  item-value="id"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs4 pl-2>
                <v-autocomplete
                  @change="setImportCategory"
                  :items="categories"
                  :loading="categoriesLoading"
                  :disabled="categoriesLoading || importLoading"
                  :label="$t('skistar.accommodations.categories.categoriesLabel')"
                  item-text="name"
                  item-value="id"
                  clearable
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout>
              <v-flex xs12>
                <v-list two-line dense>
                  <v-subheader>
                    The following accommodations will be imported:
                  </v-subheader>
                  <template
                    v-for="(accommodation, index) in selectedAccommodations"
                  >
                    <v-divider v-if="index" :key="'divider_'+ index"></v-divider>
                    <v-list-tile :key="'list_' + index">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ accommodation.name }}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          <b
                            v-if="accommodation.imported"
                            class="green--text"
                          >Imported</b>
                          {{ accommodation.id }}: {{ accommodation.description }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        </template>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/ski/skistar/SkistarAccommodationsMapping.vue